/**
 * Decode JWT payload (browser-safe, no verification).
 *
 * Admin authority is never read from the token here: it is the Kora database trust level
 * (KORA-20, KORA-165), which the server enforces on every request.
 */
const KORA_ADMIN_TRUST_LEVELS = new Set(['admin']);
/**
 * Whether a Kora trust level string grants platform admin.
 * Handles any string case; returns false for missing or non-string values.
 */
export function isKoraAdminTrustLevel(trustLevel) {
    return typeof trustLevel === 'string' && KORA_ADMIN_TRUST_LEVELS.has(trustLevel.toLowerCase());
}
/**
 * Whether a loaded Kora user has admin trust. UI affordance only; the server checks the database.
 *
 * @param koraUser - Minimal Kora user shape (only `trustLevel` is read).
 */
export function isKoraAdminTrust(koraUser) {
    return isKoraAdminTrustLevel(koraUser?.trustLevel);
}
export function parseJwtPayload(token) {
    try {
        const base64Url = token.split('.')[1];
        if (!base64Url)
            return {};
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''));
        return JSON.parse(jsonPayload);
    }
    catch {
        return {};
    }
}
